import { fetchWithRateLimitCheck } from './api';

const api_url = process.env.REACT_APP_GATEWAY_URL;

export function fetchAllDepartments() {
    return fetchWithRateLimitCheck(`${api_url}api/departments/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });
}